import {
  BaSeBackendNoSignalPage,
  BaSeDialogContainer,
  BaSeErrorPage,
  BaSeForbiddenPage,
  BaSeLoadingPage,
  BaSeNotFoundPage,
  BaSeRoot,
} from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { name as appName, version as appVersion } from '../package.json';
import { ModalProvider } from './contexts/modal';
import reportWebVitals from './reportWebVitals';
import { Routes } from './routes';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

ReactDOM.render(
  <React.StrictMode>
    <BaSeRoot>
      <Sebrae.Root
        appName={appName}
        appVersion={appVersion}
        errorPage={(error) => <BaSeErrorPage error={error} />}
        loadingPage={() => <BaSeLoadingPage />}
        notFoundPage={() => <BaSeNotFoundPage />}
        forbiddenPage={() => <BaSeForbiddenPage />}
        backendNoSignalPage={() => <BaSeBackendNoSignalPage />}
      >
        <ModalProvider>
          <Routes />
        </ModalProvider>
        <BaSeDialogContainer />
      </Sebrae.Root>
    </BaSeRoot>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
